import * as React from "react";
import {Document, Page, StyleSheet, Text, View, Image} from "@react-pdf/renderer";
import nluisLogo from "./../../../../resources/img/nlus.png"
import Table from "./report_table";

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white'
    },
    section: {
        margin: 5,
        padding: 5,
        flexGrow: 1,
        textAlign: "center",
        fontSize: 14
    },
    image: {
        width: '25%',
        height: '28%',
        alignSelf: "center"
    }
});

const data = {
    id: "5df3180a09ea16dc4b95f910",
    header:[{object1:'No.', object2:'Project Name', object3:'Registration Date',object4:'Approval Date'}],
    items: [
        {
            object1: 1,
            object2: "Mnase Village Land Use",
            object3: '2023-04-18 11:48:55',
            object4: '2023-04-18 11:48:55'
        },
        {
            object1: 2,
            object2: "Chamwino District Land Use",
            object3: '2023-04-18 11:48:55',
            object4: '2023-04-18 11:48:55'
        },
    ],
};

export default class ApprovedLandUseReport extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (<Document>
            <Page size="A4" style={styles.page} orientation={"landscape"}>
                <div  style={styles.image}>
                    <Image src={nluisLogo} cache={false}/>
                </div>
                <View style={styles.section}>
                    <Text>National Land Use Information System (NLUIS)</Text>
                    <Text>Approved Land Use Projects</Text>
                    <Table data={data}/>
                </View>
            </Page>
        </Document>)

    }
}
